module.exports = __webpack_public_path__ + "img/footer_logo.b231758a.png";